import { render } from "./LevelsList.vue?vue&type=template&id=7d6beacf&scoped=true&ts=true"
import script from "./LevelsList.vue?vue&type=script&lang=ts"
export * from "./LevelsList.vue?vue&type=script&lang=ts"

import "./LevelsList.vue?vue&type=style&index=0&id=7d6beacf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6beacf"]])

export default __exports__